import { SelectContextItem } from '../models';
import { getAppLink } from './app-link-config';

export const getPagesLink = (organization: string, tenantName: string, path: string, uiContext: SelectContextItem) => {
  const { itemId: sc_itemid, language: sc_lang, siteName: sc_site } = uiContext;

  return getAppLink({ app: 'pages', path, params: { organization, tenantName, sc_itemid, sc_lang, sc_site } });
};
